import { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Wheel } from '../react-custom-roulette';
import { challenges } from '../challenges';
import { ReactComponent as Close } from '../images/close.svg';

// Button for debugging / to open modal without waiting for wheel animation to finish
// import { Button } from 'reactstrap';

// https://github.com/effectussoftware/react-custom-roulette#readme

const colors = ['#932EF4', '#2A59DB', '#F01A1A', '#62D43F', '#F5AB32'];

const data = challenges.map((challenge, index) => {
  const img = new Image();
  img.src = challenge.icon;

  return {
    option: `${index}`,
    character: img,
    modalHeader: challenge.title,
    modalBody: challenge.info,
  };
});

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

const defaultButtonText = isTouchDevice() ? (
  <>
    Tap to
    <br />
    Spin
  </>
) : (
  <>
    <span className="d-none d-sm-inline">
      Click Here
      <br />
      to Spin
    </span>
    <span className="d-sm-none">
      Tap to
      <br />
      Spin
    </span>
  </>
);

const SpinWheel = () => {
  const [buttonText, setButtonText] = useState(defaultButtonText);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);

  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
  };

  const [modal, setModal] = useState(false);
  const toggle = () => {
    if (modal) {
      setButtonText(
        <>
          <div className="spin-again">Spin Again</div>
        </>
      );
    }
    setModal(!modal);
  };

  const onStopSpinning = () => {
    setMustSpin(false);
    setModal(true);
  };

  return (
    <>
      {/* <div className="my-4">
        <Button color="primary" onClick={toggle}>
          Open Modal
        </Button>
      </div> */}
      <Wheel
        mustStartSpinning={mustSpin}
        prizeNumber={prizeNumber}
        data={data}
        onStopSpinning={onStopSpinning}
        backgroundColors={colors}
        innerRadius={20}
        perpendicularText={true}
        textDistance={94}
        fontSize={20}
        width={800}
        height={800}
        handleSpinClick={handleSpinClick}
        buttonText={buttonText}
        modalIsOpen={modal}
      />
      {/* ---------------------------------------------- */}
      <Modal isOpen={modal} toggle={toggle} size="lg" className="modal-dialog-centered text-center">
        <ModalHeader
          toggle={toggle}
          close={
            <button type="button" onClick={toggle} className="btn-close" aria-label="Close">
              <Close />
            </button>
          }
        ></ModalHeader>
        <ModalBody className="text-uppercase">
          <div className="modal-body-inner">
            <div className="h1 mb-4">{data[prizeNumber].modalHeader}</div>
            <div className="h2 mb-0 mb-lg-4">{data[prizeNumber].modalBody}</div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SpinWheel;
